<!-- 系统订单-包车 -->

<template>
  <div class="chartered-bus-dialog">
    <w-dialog ref="dialogRef" class="by-person" title="接单确认" width="60%" top="5vh" confirmText="确认接单"
      @wConfirm="handleSure">
      <el-form class="add-form" ref="formRef" :model="ruleForm" :rules="rules" labelPosition="top">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="包车数量" prop="count">
              <el-input v-model="ruleForm.count" type="number" placeholder="请输入包车数量" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发车时间" prop="departure_time">
              <!-- <el-date-picker v-model="ruleForm.departure_time" type="datetime" placeholder="请选择发车时间"
                format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm" clearable
                :disabled-date="departDisabledDate" /> -->
              <el-col :span="12" style="padding: 0;width: 100%;">
                <el-date-picker v-model="ruleForm.departDate" type="date" format="YYYY-MM-DD" value-format="YYYY-MM-DD"
                  placeholder="请选择日期" disabled />
              </el-col>
              <el-col :span="12" style="padding-right: 0;width: 100%;">
                <el-time-picker v-model="ruleForm.departTime" format="HH:mm" value-format="HH:mm" placeholder="请选择时间" />
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="预计抵达时间" prop="arrival_time">
              <!-- <el-date-picker v-model="ruleForm.arrival_time" type="datetime" placeholder="请选择预计抵达时间"
                format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm" clearable
                :disabled-date="departDisabledDate" /> -->
              <el-col :span="12" style="padding: 0;width: 100%;">
                <el-date-picker v-model="ruleForm.arrivalDate" type="date" format="YYYY-MM-DD" value-format="YYYY-MM-DD"
                  placeholder="请选择日期" disabled />
              </el-col>
              <el-col :span="12" style="padding-right: 0;width: 100%;">
                <el-time-picker v-model="ruleForm.arrivalTime" format="HH:mm" value-format="HH:mm"
                  placeholder="请选择时间" />
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-for="(list, index) in car_driver_list" :key="index">
          <el-col :span="24">
            <div class="car-title">车辆{{ toChineseNumber(index + 1) }}</div>
          </el-col>
          <el-col :span="12">
            <el-form-item label="接单车辆信息" prop="car_id">
              <el-select v-model="list.car_id" placeholder="请选择" filterable @change="carChange(list, index)">
                <el-option v-for="(item, i) in carOptions" :key="i" :label="item.plate" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="司机信息" prop="driver">
              <el-select v-model="list.driver" :remote-method="(query) => getDriverOptions(query, index)" filterable
                remote clearable placeholder="请选择司机" :loading="isLoading">
                <el-option v-for="item in list.driverOptions" :key="item.u_id" :label="item.u_name" :value="item.u_id">
                  <el-row>
                    <el-col :span="8">{{ item.u_name }}</el-col>
                    <el-col :span="10">{{ item.u_tel }}</el-col>
                    <el-col :span="6">{{ item.du_name }}</el-col>
                  </el-row>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </w-dialog>
  </div>
</template>

<script>
import { ref, reactive, } from "vue";
import { VipApi, } from "@/plugins/api.js";
import { ElMessage, } from "element-plus";

export default {
  emits: ["submit"],
  components: {},
  setup(props, { emit }) {
    const dialogRef = ref(null);  // 弹框对象
    const carOptions = ref([]); // 车辆
    const isLoading = ref(false); // 司机列表加载状态
    const formRef = ref(null);
    const car_driver_list = ref([]);  // 车辆司机列表
    const ruleForm = ref({
      order_id: '',  // 订单id
      count: '',  // 乘车人数量
      departure_time: '',  // 发车时间
      arrival_time: '',  // 预计抵达时间
      departDate: '',  // 发车日期
      departTime: '',  // 发车时间
      arrivalDate: '',  // 预计抵达日期
      arrivalTime: '',  // 预计抵达时间
    });
    const rules = reactive({
      count: [
        { required: true, message: "请输入乘车人数", trigger: "blur", },
      ],
    });

    /**
     * 
     * 打开对话框
     * 
     * **/
    const openDialog = (row) => {
      ruleForm.value.order_id = row.or_id;
      ruleForm.value.count = row.oc_number;
      ruleForm.value.departure_time = '';
      ruleForm.value.arrival_time = '';
      ruleForm.value.departDate = row.oc_subscribe_stime ? new Date(row.oc_subscribe_stime).toISOString().split('T')[0] : '';
      ruleForm.value.departTime = row.oc_subscribe_stime ? new Date(row.oc_subscribe_stime).toTimeString().split(' ')[0].slice(0, -3) : '';
      ruleForm.value.arrivalDate = row.oc_subscribe_etime ? new Date(row.oc_subscribe_etime).toISOString().split('T')[0] : '';
      ruleForm.value.arrivalTime = row.oc_subscribe_etime ? new Date(row.oc_subscribe_etime).toTimeString().split(' ')[0].slice(0, -3) : '';
      car_driver_list.value = [];
      for (let i = 0; i < row.oc_number; i++) {
        car_driver_list.value.push({
          car_id: '',
          driver: '',
          car_records_id: '',
          driver_name: '',
          driverOptions: [],
        }); // 初始化车辆司机列表
      }
      getAvailableCarList();
      dialogRef.value.show();
    }
    /**
     * 
     * 关闭对话框
     * 
     * **/
    const closeDialog = () => {
      dialogRef.value.close();
    }
    /**
     * 
     * 关闭对话框加载状态
     * 
     * **/
    const closeDialogLoading = () => {
      dialogRef.value.isLoading = false;
    }

    /**
     * 
     * 获取可用车辆列表
     * 
     * **/
    const getAvailableCarList = () => {
      VipApi.getAvailableCarList({ req_type: 3, }).then((res) => {
        if (res.Code == 200) {
          carOptions.value = res.Data;
        }
      });
    }
    /**
     * 
     * 获取司机
     * 
     * **/
    const getDriverOptions = (query, index) => {
      isLoading.value = true;
      VipApi.searchCarDiver({ keyword: query, }).then((res) => {
        isLoading.value = false;
        if (res.Code == 200) {
          car_driver_list.value[index].driverOptions = res.Data;
        }
      });
    }
    /**
     * 
     * 选择车辆
     * 
     * **/
    const carChange = (list, i) => {
      const selectedCar = carOptions.value.find(car => car.id === car_driver_list.value[i].car_id);
      if (selectedCar) {
        car_driver_list.value[i].car_records_id = selectedCar.car_records_id; // 更新车辆记录id
        if (selectedCar.driver_list.length > 0) {
          car_driver_list.value[i].driver = selectedCar.driver_list[0].u_id; // 更新车辆司机列表中的剩余座位数
          car_driver_list.value[i].driver_name = selectedCar.driver_list[0].u_name; // 清空司机信息
          getDriverOptions(selectedCar.driver_list[0].u_name, i);
        }
      } else {
        car_driver_list.value[i].driver = ''; // 如果没有选中车辆，清空司机信息
        car_driver_list.value[i].car_records_id = ''; // 如果没有选中车辆，清空车辆记录id
        car_driver_list.value[i].driver_name = ''; // 如果没有选中车辆，清空司机名称
      }
    }
    /**
     * 
     * 禁用日期
     * 
     * **/
    const departDisabledDate = () => {
      return true;
    }
    /**
     * 
     * 禁用过去的日期
     * 
     * **/
    const arriveDisabledDate = (time) => {
      return time.getTime() < Date.now() - 86400000; // Date.now() - 86400000 将当前时间减去一天的毫秒数，确保只能选择今天及以后
    }
    /**
     * 
     * 数字转换大写
     * 
     * **/
    const toChineseNumber = (val) => {
      const chineseNumbers = ['', '一', '二', '三', '四', '五', '六', '七', '八', '九',];
      const chineseUnits = ['', '十', '百', '千', '万', '亿',];
      if (val == 0) {
        return chineseNumbers[0];
      }
      let result = '';
      let unitIndex = 0;
      const valueOle = val;
      while (val > 0) {
        const digit = val % 10;
        if (digit !== 0 || unitIndex == 1) {
          result = chineseNumbers[digit] + chineseUnits[unitIndex] + result;
        }
        val = Math.floor(val / 10);
        unitIndex++;
      }

      if (valueOle > 9 && valueOle < 20) {
        result = result.slice(1);
      }
      return result;
    }
    /**
     * 
     * 确认提交
     * 
     * **/
    const handleSure = () => {
      formRef.value.validate((valid) => {
        if (valid) {
          if (car_driver_list.value.length == 0) {
            ElMessage.error('请至少选择一辆车');
            return;
          }
          if (!ruleForm.value.departDate) {
            ElMessage.error('请选择发车日期！');
            return;
          }
          if (!ruleForm.value.departTime) {
            ElMessage.error('请选择发车时间！');
            return;
          }
          if (!ruleForm.value.arrivalDate) {
            ElMessage.error('请选择预计抵达日期！');
            return;
          }
          if (!ruleForm.value.arrivalTime) {
            ElMessage.error('请选择预计抵达时间！');
            return;
          }
          for (let i = 0; i < car_driver_list.value.length; i++) {
            if (!car_driver_list.value[i].car_id) {
              ElMessage.error(`请为车辆${toChineseNumber(i + 1)}选择车辆`);
              return;
            }
            if (!car_driver_list.value[i].driver) {
              ElMessage.error(`请为车辆${toChineseNumber(i + 1)}选择司机`);
              return;
            }
          }
          dialogRef.value.isLoading = true;
          ruleForm.value.arrival_time = `${ruleForm.value.arrivalDate} ${ruleForm.value.arrivalTime}`;
          ruleForm.value.departure_time = `${ruleForm.value.departDate} ${ruleForm.value.departTime}`;
          let datas = {
            ...ruleForm.value,
            car_driver_list: car_driver_list.value.map(item => ({
              car_id: item.car_id,
              driver: item.driver,
              car_records_id: item.car_records_id,
            })),
          };
          emit("submit", datas);
        }
      })
    }


    return {
      openDialog,
      dialogRef,
      closeDialog,
      closeDialogLoading,
      formRef,
      ruleForm,
      rules,
      handleSure,
      getDriverOptions,
      isLoading,
      departDisabledDate,
      arriveDisabledDate,
      carOptions,
      carChange,
      car_driver_list,
      toChineseNumber,
    };
  },
};
</script>

<style lang="scss">
.chartered-bus-dialog {
  .el-dialog__body {
    height: 640px;
    overflow: auto;
  }

  .el-form-item__content {
    height: 40px;
  }

  .car-title {
    color: #262C30;
    font-weight: bold;
    margin-bottom: 10px;
  }
}
</style>